//#region src/client/util/pkce.ts
const generateCodeVerifier = (len = 64) => {
	const characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
	let codeVerifier = "";
	for (let i = 0; i < len; i++) codeVerifier += characters.charAt(Math.floor(Math.random() * 62));
	return codeVerifier;
};
const generateChallenge = async (codeVerifier) => {
	const data = new TextEncoder().encode(codeVerifier);
	const digest = await crypto.subtle.digest("SHA-256", data);
	const uint8Array = Array.from(new Uint8Array(digest));
	return window.btoa(String.fromCharCode.apply(null, uint8Array)).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
};
const generatePkceConfig = async () => {
	const codeVerifier = generateCodeVerifier(64);
	return {
		challenge: await generateChallenge(codeVerifier),
		codeVerifier
	};
};

//#endregion
export { generatePkceConfig };